var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"v-technical-work"}},[_c('div',{attrs:{"id":"c-navigation-logo"}}),_c('h1',[_vm._v("Ведутся технические работы")]),_c('span',[_vm._v("Портал дистанционного обучения \"Система развития навыков\" временно не доступен.")])])
}]

export { render, staticRenderFns }